<template>
  <div class="form-group">
    <div v-for="(choice, index) in inputData.Choices" :key="index" class="form-row">
      <div class="col-3">
        <label v-bind:for="'choice' + index">Designator</label>
        <input
          type="text"
          class="form-control"
          v-bind:id="'choice' + index"
          v-model="choice.Choice"
          v-on:change="inputDataChange()"
          required
        />
      </div>
      <div class="col-9">
        <label v-bind:for="'text' + index">Choice Text</label>
        <input
          type="text"
          class="form-control"
          v-bind:id="'text' + index"
          placeholder="Choice text..."
          v-model="choice.Text"
          v-on:change="inputDataChange()"
          required
        />
      </div>
    </div>
    <div class="text-center mt-2">
      <button type="button" class="btn btn-primary" v-on:click="AddChoice">Add Choice</button>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  props: {
    InputData: Object
  },
  data() {
    return {
      inputData: {Choices: [{Choice: 'A', Text: ""}]}
    }
  },
  mounted(){
    if(this.InputData != null){
      this.inputData = this.InputData;
    }
    this.inputDataChange();
    var view = this;
     var CONTROL_INTERVAL = setInterval(function() {
      if ($("#text" + (view.inputData.Choices.length - 1)).length > 0) {
        $("#text" + (view.inputData.Choices.length - 1)).focus();
        clearInterval(CONTROL_INTERVAL);
      }
    }, 100);
  },
  watch:{
    InputData: function(){
      if(this.InputData != null){
      this.inputData = this.InputData;
      this.inputDataChange();
      }
    }
  },
  methods: {
    inputDataChange(){
      this.$emit('input-data-change', this.inputData)
    },
    AddChoice(){
      var view = this;
      var newChoice = 'A';
      switch(view.inputData.Choices.length){
        case 1:
          newChoice = 'B';
          break;
        case 2:
          newChoice = 'C';
          break;
        case 3:
          newChoice = 'D';
          break;
        case 4:
          newChoice = 'E';
          break;
        case 5:
          newChoice = 'F';
          break;
        case 6:
          newChoice = 'G';
          break;
        case 7:
          newChoice = 'H';
          break;
        case 8:
          newChoice = 'I';
          break;
        case 9:
          newChoice = 'J';
          break;
        case 10:
          newChoice = 'K';
          break;
        case 11:
          newChoice = 'L';
          break;
      }
      view.inputData.Choices.push({Choice: newChoice, Text: ""});
      view.inputDataChange();
      
      var CONTROL_INTERVAL = setInterval(function() {
          if ($("#text" + (view.inputData.Choices.length - 1)).length > 0) {
            $("#text" + (view.inputData.Choices.length - 1)).focus();
            clearInterval(CONTROL_INTERVAL);
          }
        }, 100);
    }
  }
}
</script>